<template>
  <div class="cabinet-list-container">
    <div class="jc-page-top">
      <div class="instance-list">
        <div class="jc-page-header">
          <h1>
            <i class="jc-icon-my-circle-bold"></i>{{$t('text.cabinet')}}
          </h1>
          <div class="jc-box-action">
            <a v-bind:href="Config.CABINET_SERVER_URL"
               target="_blank">{{$t('cabinet.helpDoc',[$t('text.cabinet')])}}</a>
          </div>
        </div>
        <div class="jc-page-content">
          <!-- SearchListPane组件 -->
          <SearchListPane
            ref="searchPane"
            :search-configs="searchConfigs"
            :search-form-data="searchForm"
            @search="handleSearch"
            @reset="handleReset"
            :default-visible-count="3"
            :show-collapse-button="true"
          />
          <div class="el-container-table common-table-container">
            <div class="el-container-table-actionBar ">
              <el-form class="el-box-table-search"
                       :inline="true"
                       @submit.native.prevent>
                <!-- <el-form-item>
                  <el-input :placeholder="$t('placeholder.searchMoreCabinetNo')"
                            v-model="searchValue"
                            @keyup.enter.native="handleIconClick"
                            class="my-input" clearable @clear="handleIconClick">
                    <el-button slot="append"
                               @click="handleIconClick"
                               icon="el-icon-search"
                               class="search-icon"></el-button>
                  </el-input>
                </el-form-item> -->
                <!-- tag -->
                <el-form-item class="set-icon">
                  <jcb-tag-filter :service-code="ServiceCodeConstant.CCS"
                                  :visible.sync="batchEditTagDialogVisible"
                                  :region-id="TagRegionID"
                                  @checkedTags="filterWithCheckedTags">
                  </jcb-tag-filter>
                </el-form-item>
                <el-form-item class="set-icon">
                  <el-button icon="el-icon-setting"
                             class="el-button-icon"
                             @click="setCustom"
                             :title="$t('merge.customList')"></el-button>
                </el-form-item>
                <el-form-item>
                  <el-button icon="jc-icon-download"
                             class="el-button-icon"
                             @click="exportList"
                             :title="$t('speechcraft.exportResourceList')"></el-button>
                </el-form-item>
              </el-form>
              <el-form class="el-table-actionBar-item"
                       :inline="true">
                <el-form-item>
                  <el-button icon="jc-icon-refresh-line"
                             class="el-button-icon"
                             @click="refreshList('refresh')"
                             ></el-button>
                </el-form-item>
                <el-form-item>
                  <!-- <el-select v-model="selectRoom" :placeholder="$t('placeholder.choose')">
                    <el-option
                      v-for="room in computerRoom"
                      :key="room.id"
                      :value="room.id"
                      :label="room.name">
                    </el-option>
                  </el-select> -->
                </el-form-item>
              </el-form>
            </div>
            <!-- // 新引入 -->
            <div class="el-container-table">
              <el-table :data="tableData"
                        tooltip-effect="light"
                        ref="table"
                        v-loading="refreshloading"
                        :empty-text="tableEmptyTip"
                        v-if="tableData && tableVisiable"
                        @selection-change="handleSelectionChange"
                        @sort-change="handleSortChange"
                        @filter-change="changeFilter">
                <el-table-column
                  type="selection"
                  width="55"
                  v-if="customInfo !== null">
                </el-table-column>
                <el-table-column prop="cabinetId"
                                 key="cabinetId"
                                 min-width="140"
                                 :label="$t('text.id')"
                                 v-if="getCustomInfoSelect('cabinetId')"
                                 fixed>
                  <template slot-scope="scope">
                    <a href="javascript:void(0)"
                       @click="jump_to_detail(scope.row.cabinetNo,scope.row.cabinetId,scope.row.regionEn)"
                       class="a-link-text">{{scope.row.cabinetId}}</a>
                  </template>
                </el-table-column>
                <!-- 机柜编码 -->
                <el-table-column prop="cabinetNo"
                                 key="cabinetNo"
                                 sortable

                                 min-width="150"
                                 :label="$t('cabinet.cabinetNumCode')"
                                 v-if="getCustomInfoSelect('cabinetNo')"
                                 fixed>
                  <template slot-scope="scope">
                    <a href="javascript:void(0)"
                       @click="jump_to_detail(scope.row.cabinetNo,scope.row.cabinetId,scope.row.regionEn)"
                       class="a-link-text">{{scope.row.cabinetNo}}</a>
                  </template>
                </el-table-column>
                <!-- 机房名称 -->
                <el-table-column prop="datacenterNameShow"
                                 key="datacenterNameShow"
                                 min-width="160"
                                 :label="$t('cabinet.roomName')"
                                 v-if="getCustomInfoSelect('datacenterNameShow')">
                </el-table-column>
                <!-- 原 机房名称 改为 节点 -->
                <el-table-column prop="regionShow"
                                 key="regionShow"
                                 min-width="160"
                                 :label="$t('idcs.region')"
                                 v-if="getCustomInfoSelect('regionShow')">
                </el-table-column>
                <!-- 房间号 -->
                <el-table-column prop="roomNo"
                                 key="roomNo"
                                 columnKey="roomNo"
                                 sortable
                                 min-width="120"
                                 :label="$t('text.roomNum')"
                                 v-if="getCustomInfoSelect('roomNo')">
                </el-table-column>
                <!-- 机柜空间 -->
                <el-table-column prop="cabinetSpace"
                                 key="cabinetSpace"
                                 min-width="95"
                                 :label="$t('cabinet.cabinetSpace')"
                                 v-if="getCustomInfoSelect('cabinetSpace')">
                  <template slot-scope="scope">
                    <span>{{scope.row.cabinetSpace}}</span>
                  </template>
                </el-table-column>


                <!-- 额定电流 -->
                <el-table-column prop="cabinetPower"
                                 key="cabinetPower"
                                 min-width="95"
                                 :label="$t('cabinet.ratedCurrent')"
                                 v-if="getCustomInfoSelect('cabinetPower')"
                                 show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span v-if="scope.row.cabinetPower!== ''">{{scope.row.cabinetPower}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>

                <!-- 设备数量 -->
                <el-table-column prop="deviceNum"
                                 key="deviceNum"
                                 min-width="95"
                                 :label="$t('equipment.equipmentQuantity')"
                                 v-if="getCustomInfoSelect('deviceNum')">
                  <template slot-scope="scope">
                    <span>{{scope.row.deviceNum}}</span>
                  </template>
                </el-table-column>

                <!-- 机柜类型 -->

                <el-table-column prop="cabinetType"
                                 key="cabinetType"
                                 :label="$t('cabinet.cabinetType')"
                                 columnKey="cabinetType"
                                 min-width="100"
                                 v-if="getCustomInfoSelect('cabinetType')">
                  <template slot-scope="scope">
                    <span>{{scope.row.cabinetTypeName}}</span>
                  </template>
                </el-table-column>
                <!-- 开通状态 -->
                <el-table-column prop="cabinetOpenStatus"
                                 key="cabinetOpenStatus"
                                 columnKey="cabinetOpenStatus"
                                 min-width="100"
                                 :label="$t('cabinet.EnablingStatus')"
                                 v-if="getCustomInfoSelect('cabinetOpenStatus')">

                    <template slot-scope="scope">
                    <span v-if="scope.row.cabinetOpenStatus!== ''">{{scope.row.cabinetOpenStatusName}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>

                <!-- 计费信息 -->
                <el-table-column prop="cabinetOpenTime"
                                 key="cabinetOpenTime"
                                 min-width="220"
                                 :label="$t('cabinet.billingInfo')"
                                 v-if="getCustomInfoSelect('billingInfo')">
                  <template slot-scope="scope">
                    <!-- 预留机柜 -->
                    <div v-if="scope.row.cabinetType === 'reserved'">
                      <span>{{$t('cabinet.reserveStartTime')}}: {{scope.row.reserveStartTime || '--'}}</span><br/>
                      <span>{{$t('cabinet.reserveEndTime')}}: {{scope.row.reserveEndTime || '--'}}</span>
                    </div>
                    <!-- 正式机柜 -->
                    <div v-else-if="scope.row.cabinetType === 'formal'">
                      <span>{{$t('cabinet.billingTime')}}: {{scope.row.startTime || '--'}}</span><br/>
                      <span>{{$t('cabinet.expireTime')}}: {{scope.row.endtime || '--'}}</span>
                    </div>
                    <div v-else>--</div>
                  </template>
                </el-table-column>

                <!-- 开通时间 -->

                <!-- <el-table-column prop="cabinetOpenTime"
                                 key="cabinetOpenTime"
                                 min-width="120"
                                 :label="$t('cabinet.EnablingTime')"
                                 v-if="customInfo !== null &&  customInfo['cabinetOpenTime'].selected">
                  <template slot-scope="scope">
                    <span v-if="scope.row.cabinetOpenTime!== ''">{{scope.row.cabinetOpenTime}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column> -->

                <!-- 起租时间 -->
                <!-- <el-table-column prop="startTime"
                                 key="startTime"
                                 :label="$t('cabinet.rentingTime')"
                                 v-if="customInfo !== null && customInfo['startTime'].selected"
                                 show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span v-if="scope.row.startTime!== ''">{{scope.row.startTime}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column> -->
                <!-- 到期时间 -->
                <!-- <el-table-column prop="expireTime"
                                 key="expireTime"
                                 :label="$t('cabinet.expireTime')"
                                 v-if="customInfo !== null && customInfo['expireTime'].selected">
                  <template slot-scope="scope">
                    <span v-if="scope.row.expireTime!== ''">{{scope.row.expireTime}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column> -->
                <!-- 预留开始时间 -->
                <!-- <el-table-column prop="reserveStartTime"
                                 key="reserveStartTime"
                                 min-width="95"
                                 :label="$t('cabinet.reserveStartTime')"
                                 v-if="customInfo !== null && customInfo['reserveStartTime'].selected">
                  <template slot-scope="scope">
                    <span v-if="scope.row.reserveStartTime!== ''">{{scope.row.reserveStartTime}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column> -->
                <!-- 预留结束时间 -->
                <!-- <el-table-column prop="reserveEndTime"
                                 key="reserveEndTime"
                                 min-width="120"
                                 :label="$t('cabinet.reserveEndTime')"
                                 v-if="customInfo !== null && customInfo['reserveEndTime'].selected">
                  <template slot-scope="scope">
                    <span v-if="scope.row.reserveEndTime!== ''">{{scope.row.reserveEndTime}}</span>
                    <span v-else>--</span>
                  </template>
                </el-table-column> -->
                <el-table-column :label="$t('text.tags')"
                              key="tags"
                              v-if="getCustomInfoSelect('tags')"
                              min-width="100"
                              class-name="p-line-break">
                <template slot-scope="scope">
                  <p>{{scope.row.tagPairs | maybeEmpty}}</p>
                </template>
              </el-table-column>
                <!--操作-->
                <el-table-column key="operate"
                                    min-width="100"
                                 :label="$t('text.operate')"
                                 fixed="right">
                  <template slot-scope="scope">
                    <!-- <el-button type="text"
                                @click="clickOperateTag(scope.row)">
                        {{ $t('text.editTag') }}
                      </el-button> -->
                      <!--机柜视图-->
                      <el-button type="text"
                                @click="onCabVisDialogOpen(scope.row)">
                        {{ $t('cabinetVisual.label') }}
                      </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <custom :visible.sync="customVisible"
                v-if="customVisible"
                :optionArr="optionArr"
                :type="type"></custom>
      </div>
    </div>
    <div class="el-page-footer block el-container-table-actionBar"
         v-if="tableData.length">
      <el-tooltip class="item" effect="dark" :content="$t('text.pleaseSelectResource')" :disabled="!!multipleSelection.length" :visible-arrow="false" placement="top">
        <el-button type="primary" class="margin-top-ten"  :disabled="!multipleSelection.length" @click="batchEditTag">{{$t('text.editTag')}}</el-button>
      </el-tooltip>

      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="pageSizeArr"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>
    <!--机柜视图弹窗-->
    <el-dialog v-if="cabVisSelected"
               :title="$t('cabinetVisual.label1', [cabVisSelected.cabinetNo, cabVisSelected.roomNo])"
               :lock-scroll="true"
               :visible.sync="cabVisDialog">
      <carbin-visual :data="cabVisSelected"
                     style="max-width: 61.8%;" />
      <span slot="footer"
            class="dialog-footer"></span>
    </el-dialog>

    <!--编辑标签-->
    <jcb-tag-edit :visible.sync="editTagDialogVisible"
                  :service-code="ServiceCodeConstant.CCS"
                  :region-id="TagRegionID"
                  :resource-ids="resourceId"
                  @complete="updateList('refresh', true)">
    </jcb-tag-edit>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import custom from '../common/custom/Custom.vue';
import carbinVisual from '../cabinetVisual/CabinetVisual';
import SearchListPane from '../common/search/SearchListPane.vue';
import { ServiceCodeConstant } from '@/common/Constants';
import searchOperate from '@/mixins/searchOperate'
import { handleChangeAllSelectedValue, AllId } from '@/utils/common/index'
import customInfoSelect from '@/mixins/customInfoSelect'

export default {
  name: 'List',
  components: {
    custom,
    carbinVisual,
    SearchListPane
  },
  mixins: [searchOperate, customInfoSelect],
  data () {
    return {
      AllId,
      // 机房状态（暂时增加）
      cabinetStatus: '',
      name: 'cabinetList',
      refreshloading: false, // 刷新
      currentPage: 1, // 当前页数
      pageSize: 20, // 当前显示数据个数
      pageSizeArr: [20, 50, 100], // 每页显示总数
      total: 0, // 数据总数
      tableData: [], // 机柜表格数据
      searchValue: '', // 机柜编号搜索框
      customVisible: false, // 自定义
      cabVisDialog: false, // 控制机柜可视化弹窗是否显示
      cabVisSelected: null, // 可视化弹窗展示的选中数据
      type: 'cabinet',
      optionArr: [

        {
          // 机柜编ID
          label: this.$t('text.id'),
          value: 'cabinetId'
        },
        {
          // 机柜编码
          label: this.$t('cabinet.cabinetNumCode'),
          value: 'cabinetNo'
        },
        {
          // 机房名称
          label: this.$t('cabinet.roomName'),
          value: 'datacenterNameShow'
        },
        {
          // 节点
          label: this.$t('idcs.region'),
          value: 'regionShow'
        },
        {
          // 房间号
          label: this.$t('text.roomNum'),
          value: 'roomNo'
        },
        {
          // 机柜空间
          label: `${this.$t('cabinet.cabinetSpace')}`,
          value: 'cabinetSpace'
        },

        {
          // 额定电流
          label: `${this.$t('cabinet.ratedCurrent')}`,
          value: 'cabinetPower'
        },
        {
          // 设备数量
          label: this.$t('equipment.equipmentQuantity'),
          value: 'deviceNum'
        },
        {
          // 机柜类型
          label: this.$t('cabinet.cabinetType'),
          value: 'cabinetType'
        },
        {
          // 开通状态
          label: `${this.$t('cabinet.EnablingStatus')}`,
          value: 'cabinetOpenStatus'
        },
        // 计费信息
        {
          label: this.$t('cabinet.billingInfo'),
          value: 'billingInfo'
        },
        // {
        //   // 开通时间
        //   label: this.$t('cabinet.EnablingTime'),
        //   value: 'cabinetOpenTime'
        // },
        // {
        //   // 起租时间
        //   label: this.$t('cabinet.rentingTime'),
        //   value: 'startTime'
        // },
        // {
        //   // 到期时间
        //   label: this.$t('cabinet.expireTime'),
        //   value: 'expireTime'
        // },
        // {
        //   // 预留开始时间
        //   label: this.$t('cabinet.reserveStartTime'),
        //   value: 'reserveStartTime'
        // },
        // {
        //   // 预留结束时间
        //   label: this.$t('cabinet.reserveEndTime'),
        //   value: 'reserveEndTime'
        // },
        {
          // 标签
          label: this.$t('text.tags'),
          value: 'tags'
        },
        {
          // 操作
          label: this.$t('text.operate'),
          value: 'operation'
        }
      ],
      multipleSelection: [],
      selectArr: ['cabinetNo', 'roomNo', 'cabinetSpace', 'cabinetType', 'cabinetStatus', 'cabinetPower', 'startTime', 'endTime'], // 自定义操作菜单
      disableArr: ['cabinetNo'], // 自定义禁止操作菜单
      computerRoom: [], // 机房数据
      selectRoom: '',
      tableEmptyTip: '', // 表格提示文本
      tableEmptyMap: { // 表格提示文本
        search: this.$t('text.hasSearch'),
        noSearch: this.$t('text.noSearch')
      },
      filtersValue: {
        roomNo: [],
        cabinetStatus: [],
        cabinetOpenStatus: [],
        cabinetType: []

      },
      filterSort: { // 排序值：升序asc,降序desc
        order: null,
        prop: null
      },
      currentSearchFlag: false, // 当前是否搜索筛选
      // cacheSearchValue: '', // 当前搜索缓存值
      initFlag: false,
      curProp: null,
      curOrder: null,
      // roomNoFilter: {},
      tableVisiable: true,
      // 编辑标签组件是否显示
      editTagDialogVisible: false,
      // 批量编辑标签组件是否显示
      batchEditTagDialogVisible: true,
      resourceId: [],
      // 标签过滤后的资源ID
      filteredResourceIds: [],
      fliter_room: [],
      // 筛选表单数据
      // SearchListPane配置
      searchConfigs: [
        {
          field: 'cabinetNo',
          type: 'input',
          label: this.$t('cabinet.cabinetNumCode'),
          placeholder: this.$t('placeholder.placeholderInputMore', [this.$t('cabinet.cabinetNumCode')]),
        },
        {
          field: 'datacenterName',
          type: 'multiple-select',
          label: this.$t('cabinet.roomName'),
          placeholder: this.$t('placeholder.placeholderSelectMore', [this.$t('cabinet.roomName')]),
          options: []
        },
        {
          field: 'cabinetId',
          type: 'input',
          label: this.$t('text.id'),
          placeholder: this.$t('placeholder.placeholderInputMore', [this.$t('text.id')]),
        },
        {
          field: 'regionEn',
          type: 'multiple-select',
          label: this.$t('idcs.region'),
          placeholder: this.$t('placeholder.placeholderSelectMore', [this.$t('idcs.region')]),
          options: []
        },
        {
          field: 'roomNo',
          type: 'multiple-select',
          label: this.$t('text.roomNum'),
          placeholder: this.$t('placeholder.placeholderSelectMore', [this.$t('text.roomNum')]),
          options: []
        },
        {
          field: 'cabinetType',
          type: 'multiple-select',
          label: this.$t('cabinet.cabinetType'),
          placeholder: this.$t('placeholder.placeholderSelectMore', [this.$t('cabinet.cabinetType')]),
          options: []
        },
        {
          field: 'cabinetOpenStatus',
          type: 'multiple-select',
          label: this.$t('cabinet.EnablingStatus'),
          placeholder: this.$t('placeholder.placeholderSelectMore', [this.$t('cabinet.EnablingStatus')]),
          options: []
        }
      ],
      searchForm: {
        cabinetNo: '', // 机柜编码
        datacenterName: [], // 机房名称
        cabinetId: '', // ID
        regionEn: [], // 节点
        roomNo: [], // 房间号
        cabinetType: [], // 机柜类型
        cabinetOpenStatus: [] // 开通状态
      },
      // 是否展开筛选
      isCollapsed: true,
    };
  },
  created () {
    if (this.$route.query.cabinetOpenStatus) {
      const statue = this.$route.query.cabinetOpenStatus;
      this.filtersValue.cabinetOpenStatus.push(statue);
    }
    this.getComputerRoom();
    if (this.$store.state.customInfo[this.type] === null) {
      this.getCustomInfo();
    }
  },
  computed: {
    ServiceCodeConstant: () => ServiceCodeConstant,
    filterList () {
      return this.$store.state.filter.filterList;
    },
    needRequireResource () {
      return !!this.selectRoom;
    },
    customInfo () {
      let obj = {};
      if (this.$store.state.customInfo[this.type] !== null) {
        obj = $.extend(true, {}, this.$store.state.customInfo[this.type]);
        this.optionArr.forEach((value, index) => {
          if (obj[value.value] === undefined) {
            obj[value.value] = {
              selected: false
            };
          }
        });
      } else {
        this.optionArr.forEach((value, index) => {
          let itemObj = {
            selected: false
          };
          itemObj.selected = index < 9;
          if (index === 0 || value.value === 'operation') {
            itemObj = {
              selected: true,
              required: true
            };
          }
          obj[value.value] = itemObj;
        });
      }
      return obj;
    }
  },
  mounted () {
  },
  watch: {
    selectRoom (newVal, oldVal) {
      // 切换机房
      if (newVal !== oldVal && oldVal != '') {
        // 清空table筛选信息
        /*
        * 首次访问该页面
        * 包括从概览页
        * */
        // if (oldVal !== '') {
        //   console.log('1111111111111');
        //   Object.keys(this.filtersValue).forEach((key) => {
        //     this.filtersValue[key] = [];
        //   });
        // }
        // this.$refs.table.clearSort();
        // this.$refs.table.clearFilter();
        Object.keys(this.filtersValue).forEach((key) => {
          this.filtersValue[key] = [];
        });
        this.curProp = null;
        this.curOrder = null;
        this.tableVisiable = false;
        this.$nextTick(() => {
          this.tableVisiable = true;
        });
        this.getListRooms();
      }
      if (this.currentPage === 1) {
        this.updateList('refresh');
      } else {
        this.initFlag = 'changeRegion';
        this.currentPage = 1;
      }
    },

    'searchForm.cabinetNo' (val) {
      this.searchValue = val;
    }
  },
  methods: {
    getListRooms () {
      let params = { all: 1, idc: this.selectRoom }
      // 选择下拉筛选的“全部”all
      params = {...params, ...handleChangeAllSelectedValue(this.selectRoom)}
      this.$api.getListRooms(params).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK') {
          if (res.data && res.data.rooms.length > 0 && res.data.rooms[0] != null) {
            const data = res.data.rooms;
            this.fliter_room = [];
            for (let i = 0; i < data.length; i++) {
              this.fliter_room.push({
                value: data[i].roomNo,
                text: data[i].roomNo
              });
            }

          } else {
            this.fliter_room = [];
          }

        } else {
          this.$message.error(res.errmsg);
        }
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        // 更新SearchListPane选项数据
        this.initSearchOptions();
      });;
    },
    batchEditTag() {
      this.resourceId = [];
      this.multipleSelection.forEach((item) => {
        this.resourceId.push(item.cabinetId);
      });
      this.editTagDialogVisible = true;
    },
    /**
     **@disc: 根据标签对实例进行过滤
     */
    filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
      console.log(filterTags, tagKeys, resourceIds);
      if (tagKeys.length !== 0) {
        this.filteredResourceIds = resourceIds;
      } else {
        this.filteredResourceIds = [];
      }
      this.updateList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 切换展开/收起筛选
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    getCustomInfo () {
      const param = {
        pageKey: this.type
      };
      this.$api.getCustomInfo(param).then((response) => {
        // var response = JSON.parse(res)
        if (response.errno === 10000 && response.data.customInfo) {
          this.$store.commit('GET_CUSTOMINFO', { value: response.data.customInfo, type: this.type });
        }
      });
    },
    refreshList () {
      this.updateList('refresh', true);
    },
    exportList () { // 导出列表
      if (!this.needRequireResource) {
        return;
      }
      let url = `/ccs-api/api/resource/exportCabinets?all=1`;
      // 全选，导出列表参数拼接 ignoreIdc = 1
      if (this.currentSearchFlag && this.searchValue !== '') {
        // url += `&cabinetNo=${this.searchValue}`;
        url += `&cabinetNo=${encodeURIComponent(this.searchValue)}`;
      }
      if (this.selectRoom && this.selectRoom !== AllId && !this.searchForm.regionEn.length && !this.searchForm.datacenterName.length) {
        // url += `&regionEn=${this.selectRoom}`;
        url += `&regionEn=${encodeURIComponent(this.selectRoom)}`;
      }
      // 下拉搜索部分
      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length > 0) {
          // url += `&${key}=${this.filtersValue[key][0]}`;
          url += `&${key}=${encodeURIComponent(this.filtersValue[key][0])}`;
        }
      });
      // 增加遍历搜索表单参数
      if (this.searchForm) {
        for (const key in this.searchForm) {
          const val = this.searchForm[key];
          if (val !== '' && val !== null && val !== undefined) {
            if (Array.isArray(val) && val.length === 0) {
              continue;
            }
            // url += `&${key}=${val}`;
            // 对数组和字符串值进行URL编码，确保特殊字符正确传递
            if (Array.isArray(val)) {
              url += `&${key}=${val.map(item => encodeURIComponent(item)).join(',')}`;
            } else {
              url += `&${key}=${encodeURIComponent(val)}`;
            }
          }
        }
      }
      // 拼接 针对 filteredResourceIds 标签 过滤的入参
      if (this.filteredResourceIds.length) {
        // url += `&cabinetId=${this.filteredResourceIds.join(' ')}`;
        url += `&cabinetId=${encodeURIComponent(this.filteredResourceIds.join(' '))}`;
      }
      // 是否有创建时间升降序
      if (this.curProp && this.curOrder) {
        // url += `&sortName=${this.curProp}&sortDirection=${this.curOrder}`;
        url += `&sortName=${encodeURIComponent(this.curProp)}&sortDirection=${encodeURIComponent(this.curOrder)}`;
      }
      console.log(url);
      window.open(url, '_self');
    },

    handleSortChange ({ prop, order }) {
      if (prop && order) {
        // 做参数转换
        this.curProp = prop;
        if (order.indexOf('desc') !== -1) {
          this.curOrder = 'desc';
        }
        if (order.indexOf('asc') !== -1) {
          this.curOrder = 'asc';
        }
      } else {
        this.curProp = null;
        this.curOrder = null;
      }
      // 状态搜做默认第一页开始
      this.currentPage = 1;
      this.updateList('refresh', true, true);
    },

    setCustom () { // 设置自定义
      this.customVisible = true;
    },
    // 根据状态筛选
    changeFilter (filter) {
      // 状态搜做默认第一页开始
      this.currentPage = 1;
      this.updateList('refresh', true, true);
    },
    async updateList (type, search, afterSearch) {
      this.refreshloading = true;
      this.tableData = [];
      if (!this.needRequireResource) {
        return;
      }
      const target = this;
      let param = {
        pageSize: this.pageSize,
        // idc: this.selectRoom
      };

      if (this.selectRoom && this.selectRoom !== AllId && !this.searchForm.regionEn.length && !this.searchForm.datacenterName.length) {
        param.regionEn = this.selectRoom;
      }
      // const roomNoData = await this.$api.getFiltersList({ idc: this.selectRoom });
      // this.roomNoFilter = roomNoData.data;

      // param.pageNumber = search ? 1 : this.currentPage;
      param.pageNumber = this.currentPage;
      if (search) {
        // 使用for...in循环处理搜索参数
        for (const key in this.searchForm) {
          const value = this.searchForm[key];
          if (Array.isArray(value) && value.length > 0) {
            // 处理数组类型参数（多选下拉框）
            param[key] = value.join(',');
          } else if (typeof value === 'string' && value.trim() !== '') {
            // 处理字符串类型参数（输入框）
            param[key] = value;
          }
        }
        // 保留原有的搜索逻辑（兼容性）
        if (this.searchValue !== null && this.searchValue.length && this.searchValue.trim() !== '') {
          // param.cabinetNo = this.$Pop.searchRegularConversion(this.searchValue);
          this.currentSearchFlag = true;
          // this.cacheSearchValue = this.$Pop.searchRegularConversion(this.searchValue);
          this.tableEmptyTip = this.tableEmptyMap.search;
        } else {
          this.searchValue = '';
          // this.cacheSearchValue = '';
          this.tableEmptyTip = this.tableEmptyMap.noSearch;
        }
      } else if (!search && !afterSearch) {
        // console.log(258888)
        this.searchValue = '';
        this.currentSearchFlag = false;
      }
      if (afterSearch) {
        param.all = 0;
        param.pageNumber = 1;
        console.log(443);
        this.currentPage = 1;
      }
      // debugger;
      // 下拉搜索部分
      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length > 0) {
          param[key] = this.filtersValue[key][0];
        }
      });
      // 是否通过标签进行筛选
      if (this.filteredResourceIds.length) {
        param.cabinetId = this.filteredResourceIds.join(' ');
      }
      // 是否有升降序
      if (this.curProp && this.curOrder) {
        param.sortName = this.curProp;
        param.sortDirection = this.curOrder;
      }
      console.log(param);
      this.$api.getListInstances(param).then((response) => {
        if (type === 'refresh') {
          this.refreshloading = false;
        }
        // var response = JSON.parse(res)
        if (response.errno === 10000 && response.data) {
          this.total = response.data.totalCount;
          if (response.data.cabinets.length === 1 && response.data.cabinets[0] === null) {
            this.tableData = [];
          } else {
            this.tableData = cloneDeep(response.data.cabinets);
            this.tableData.forEach((item) => {
              item.tagPairs = '';
              if (item.tags !== undefined && item.tags.length > 0) {
                item.tags.forEach((tag) => {
                  item.tagPairs += `${tag.key}:${tag.value},`;
                });
                item.tagPairs = item.tagPairs.substring(0, item.tagPairs.length - 1);
              }
            });
          }
          if (!this.tableData.length) {
            // 数据为空时展示的内容
            if (search) {
              this.tableEmptyTip = this.tableEmptyMap.search;
            } else {
              this.tableEmptyTip = this.tableEmptyMap.noSearch;
            }
          }
        }
      }).finally(() => {
        this.refreshloading = false;
        // this.filteredResourceIds = [];
      });
    },
    handleSizeChange (val) { // 更改数量
      this.pageSize = val,
      this.updateList('refresh', true);
    },
    handleCurrentChange (val) { // 更改页数
      console.log(val);
      this.currentPage = val;
      if (this.initFlag == 'changeRegion') {
        this.updateList('refresh');
        this.initFlag = false;
      } else if (this.initFlag == 'search') {
        this.initFlag = false;
        this.updateList('refresh', true);
      } else {
        this.updateList('refresh', true);
      }
    },
    getComputerRoom () { // 获取机房列表
      const param = {
        all: 1, idcLine: this.GLOBAL.IDCLINE,
      };
      this.$api.getComputerRoom(param).then((response) => {
        // var response = JSON.parse(res)
        if (response.errno === 10000) {
          if (response.data.idcs.length === 0) {
            return;
          }
          for (let i = 0; i < response.data.idcs.length; i++) {
            const {datacenterNameShow, datacenterNameParam ,regionEn, regionShow} = response.data.idcs[i] || {};
            const obj = {
              id: response.data.idcs[i].idc,
              name: response.data.idcs[i].idcName,
              data: response.data.idcs[i],
              datacenterNameShow,
              datacenterNameParam, // 用于搜索 区分中英文
              regionEn,
              regionShow
            };
            this.computerRoom.push(obj);
          }
          /*
          * 如果从概览页转跳至设备页
          * 则初始化selectRoom为参数中携带的idcid
          * 如果直接访问设备页
          * 则默认selectroom为idc[0]
          * */
          if (this.$route.query.selectRoom !== undefined) {
            console.log(this.$route.query.selectRoom, 'gyh');
            this.$nextTick(() => {
              this.selectRoom = this.$route.query.selectRoom;
              })
          } else if (response.data.idcs.length) {
            this.$nextTick(() => {
              // this.selectRoom = response.data.idcs[0].idc;
              this.selectRoom = AllId;
            })
          }
          this.$nextTick(() => {
            this.selectRoom.length && this.getListRooms();
          })

        }
      });
      console.log(this.computerRoom, 'lbs');
    },
    jump_to_detail (cabinetNo, id, idc) { // 跳转到机柜详情页
      const routeData = this.$router.resolve({
        path: '/cabinet/detail',
        // query: { cabinetId: id, idcId: this.selectRoom }
        query: { idcId: idc, cabinetId: id, cabinetNo: cabinetNo }
      });
      window.open(routeData.href, '_blank');
    },
    // 更新SearchListPane配置选项
    initSearchOptions() {
      // 更新机房名称选项
      const idcsOptions = this.computerRoom.length && this.computerRoom.map(room => ({
        value: room.datacenterNameParam,
        label: room.datacenterNameShow
      }));
      // 更新节点选项
      const idcOptions = this.computerRoom.length && this.computerRoom.map(room => ({
        value: room.regionEn,
        label: room.regionShow
      }));

      // 更新房间号选项
      const roomOptions = this.fliter_room.length && this.fliter_room.map(room => ({
        value: room.value,
        label: room.text
      }));

      // 更新机柜类型选项
      const cabinetTypeOptions = (this.filterList && this.filterList.cabinetType) ? [...this.filterList.cabinetType] : [];

      // 更新开通状态选项
      const openStatusOptions = (this.filterList && this.filterList.cabinetOpenStatus) ? [...this.filterList.cabinetOpenStatus] : [];

      // 更新searchConfigs中的选项
      const newSearchConfigs = this.searchConfigs.map(config => {
        if (config.field === 'datacenterName') {
          return { ...config, options: idcsOptions };
        }
        if (config.field === 'regionEn') {
          return { ...config, options: idcOptions };
        }
        if (config.field === 'roomNo') {
          return { ...config, options: roomOptions };
        }
        if (config.field === 'cabinetType') {
          return { ...config, options: cabinetTypeOptions };
        }
        if (config.field === 'cabinetOpenStatus') {
          return { ...config, options: openStatusOptions };
        }
        return config;
      });

      this.searchConfigs = newSearchConfigs;
    },
    filtersCabinetStatus () {
      return true;
    },
    clickOperateTag (data) {
      this.resourceId = [].concat([data.cabinetId]);
      this.editTagDialogVisible = true;
    },

    onCabVisDialogOpen (cabinetData) {
      // console.log("onCabVisDialogOpen", cabinetData);
      this.refreshloading = true;
      const { regionEn, cabinetNo } = cabinetData;
      this.$api.getDevicesList({ regionEn, cabinetNo }).then((response) => {
        // const response = JSON.parse(res);
        const { errno, data } = response;
        // console.log(cabinetData, idc, cabinetNo, res, errno, data);
        if (errno != 10000) return;
        this.cabVisSelected = {
          ...cabinetData,
          devices: data.devices
        };
        this.cabVisDialog = true;
      }).finally(() => {
        this.refreshloading = false;
      });
    }
  }
};
</script>

<style lang="scss">
@import "./cabinetList.scss";
</style>



// WEBPACK FOOTER //
// src/components/cabinetList/CabinetList.vue